// extracted by mini-css-extract-plugin
module.exports = {"checkBox":"AddressForm_checkBox__2JnW3","inputClasses":"AddressForm_inputClasses__2NYCq"};